import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const ReportsPage = lazy(() => import('./SalesReportsPage'));

const FinanceDashboardAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Reporting,
  routes: [
    {
      path: 'sales-reports',
      element: <ReportsPage />,
    },
  ],
};

export default FinanceDashboardAppConfig;
